<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/member' }">服务人员</el-breadcrumb-item>
            <el-breadcrumb-item>申请列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="所属项目">
                    <el-select v-model="form.project" placeholder="请选择所属项目">
                        <el-option
                            v-for="item in projects"
                            :key="item.no"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="签约状态">
                    <el-select v-model="form.state" placeholder="请选择状态">
                        <el-option label="审核中" value="1"></el-option>
                        <el-option label="审核失败" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="form.idcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <!--<div class="data-overview">-->
            <!--<div class="data-overview__statistics">-->
            <!--<div class="statistics-item">总计 <span class="text-primary">{{members.length}}</span> 人</div>-->
            <!--<div class="statistics-item">待认证 <span class="text-primary">{{preSign}}</span> 人</div>-->
            <!--<div class="statistics-item">待签约 <span class="text-primary">{{preCheck}}</span> 人</div>-->
            <!--</div>-->
            <!--<div class="table-box__tool">-->
            <!--<el-button plain>导出成员</el-button>-->
            <!--<el-button plain>导出</el-button>-->
            <!--</div>-->
            <!--</div>-->
            <div class="table">
                <el-table
                    :data="applies"
                >
                    <el-table-column
                        prop="project_name"
                        label="所属项目">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名">
                    </el-table-column>
                    <el-table-column
                        prop="idcard"
                        label="身份证号">
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        label="手机号">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        label="申请时间">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" @click="checkMember(scope.row.id, scope.row.project_id, 1)" size="medium">确认</el-button>
                            <el-button type="text" @click="checkMember(scope.row.id, scope.row.project_id, 0)" size="medium">拒绝</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--<div class="pagination">-->
                <!--<el-pagination-->
                <!--background-->
                <!--layout="prev, pager, next"-->
                <!--:total="1000">-->
                <!--</el-pagination>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'

export default {
    name: 'Applies',
    data () {
        return {
            form: {},
            applies: [],
            projects: []
        }
    },
    mounted () {
        this.getPros()
        this.getApplies()
    },
    computed: {},
    methods: {
        getApplies () {
            this.$http.get('/api/memberapply', {
                params: {}
            })
                .then(res => {
                    if (res.code === 0) {
                        this.applies = res.data.listData
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getPros () {
            this.$http.get('/api/projectlist', qs.stringify({
                keyword: ''
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.projects = res.data.listData
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        checkMember (member, project, handle) {
            this.$http.get('/api/memberverify', {
                params: {
                    id: member,
                    project_id: project,
                    status: handle
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        if (handle === 0) {
                            this.$message.success('操作成功')
                        } else {
                            this.$message.success('操作成功')
                        }
                        this.getApplies()
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";

    .data-overview {

    }
</style>
